import { ArticleForm, IArticle } from '../types/article';
import { toUtcNoon } from './toUtcNoonISOString';

export function getArticleFormValues(article: IArticle): ArticleForm {
  return {
    content: article.content,
    color: article.color,
    icon: {
      value: article.icon.id,
      label: article.icon.src,
    },
    date: toUtcNoon(new Date(article.date), 'utc'),
    image: article.image, // set image to null here.
    // Pass image to FilePond - it loads image from server and set this prop inside itself
  };
}
